<template>
    <header class="navbar navbar-fixed-top navbar-shadow">
        <div class="navbar-branding">
            <router-link :to="{name: 'dashboard'}" class="navbar-brand">
                <b>Dance</b>ERP
            </router-link>
            <span id="toggle_sidemenu_l" @click.prevent="showLeftMenu" class="ad ad-lines"></span>
        </div>


        <ul class="nav navbar-nav navbar-right">

            <li style="display: none;">
                <div class="navbar-btn btn-group">
                    <a href="/tasks/personal/" class="btn btn-sm tasks" >
                        <span class="fa fa-tasks"></span><span class="badge task_badge label-danger" >1</span>
                    </a>
                </div>
            </li>
            <li>
                <div class="navbar-btn btn-group">
                    <router-link :to="{name: 'bids-list'}" class="btn btn-sm bid" >
                        <span class="glyphicon glyphicon-comment"></span>
                        <span class="badge label-danger">{{$store.state.template.bidCount}}</span>
                    </router-link>
                </div>
            </li>
            <li style="display: none;">
                <div class="navbar-btn btn-group">
                    <a href="#" class="btn btn-sm showdock" >
                        <span class="glyphicon glyphicon-asterisk"></span>
                    </a>
                </div>
            </li>

            <li style="display: none;" class="dropdown menu-merge">
                <div class="navbar-btn btn-group">
                    <button class="btn btn-sm kill_notify ">
                        <span class="glyphicon glyphicon-volume-off "></span>
                    </button>
                </div>
            </li>


            <li class="menu-divider hidden-xs">
                <i class="fa fa-circle"></i>
            </li>
            <li class="dropdown menu-merge" :class="{open: menu.user === true}">
                <a href="#" @click.prevent="menu.user = !menu.user" class="dropdown-toggle fw600 p15" data-toggle="dropdown">
                    <img v-if="this.$store.state.user.me.avatar" class="mw60 br64 mr15" height="30px" :src="this.$store.state.user.me.avatar.small">
                    <span class="hidden-xs">{{ fullName }}</span>
                    <span class="caret caret-tp hidden-xs"></span>
                </a>
                <ul class="dropdown-menu list-group dropdown-persist header-user-menu" role="menu">

                    <li class="dropdown-footer">

                        <a href="#" @click.prevent="logout" class="auth_action">
                            <span class="fa fa-power-off pr5"></span> Выход
                        </a>

                    </li>
                </ul>
            </li>
        </ul>
    </header>
</template>

<script>
    import Auth from "../classes/Auth";

    export default {
        data() {
            return {
                menu: {
                    user: false,
                },
            };
        },
        computed: {
            fullName: function() {
                const pieces = [];
                if (this.$store.state.user.me.lastName) {
                    pieces.push(this.$store.state.user.me.lastName);
                }
                if (this.$store.state.user.me.firstName) {
                    pieces.push(this.$store.state.user.me.firstName);
                }
                return pieces.join(' ');
            },
        },
        methods: {
            logout() {
                Auth.logout();

                this.$store.commit('user/clear');
                this.$router.push({
                    name: 'login',
                    query: {
                        redirect: this.$route.fullPath
                    },
                })
            },
            showLeftMenu() {
                if (this.$store.state.template.leftMenuOpen === null) {
                    if (this.$route.name === 'dashboard') {
                        this.$store.commit('template/setLeftMenuOpen', true);
                    } else {
                        this.$store.commit('template/setLeftMenuOpen', false);
                    }
                } else {
                    this.$store.commit('template/setLeftMenuOpen', !this.$store.state.template.leftMenuOpen);
                }
            },
        },
    }
</script>